import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import {
  clearRememberMe,
  enforceRememberMePolicy,
  refreshRememberWindow,
  setRememberMe,
  getRememberMe,
} from "@/lib/rememberMe";

export function useAuthSync() {
  const queryClient = useQueryClient();

  // Apply the "Husk mig" (remember me) policy once on boot.
  useEffect(() => {
    void enforceRememberMePolicy();
  }, []);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === "SIGNED_OUT") {
        clearRememberMe();
        queryClient.clear();
      } else if (
        event === "SIGNED_IN" ||
        event === "TOKEN_REFRESHED" ||
        event === "USER_UPDATED"
      ) {
        if (event === "SIGNED_IN") {
          // Re-affirm the stored preference (also marks this browser session active).
          setRememberMe(getRememberMe());
        } else {
          refreshRememberWindow();
        }
        queryClient.invalidateQueries({ queryKey: ["current-user"] });
        queryClient.invalidateQueries({ queryKey: ["user"] });
        queryClient.invalidateQueries({ queryKey: ["subscription"] });
        queryClient.invalidateQueries({ queryKey: ["credit-balance"] });
        queryClient.invalidateQueries({ queryKey: ["family-membership"] });
      }
    });

    return () => subscription.unsubscribe();
  }, [queryClient]);
}
